@let isEditingParams =
  unassignedSponsoredPeopleEc.plugins.currentListPlugin.feature.selectors.isEditingParams.asSignal();
@let isEditingComment =
  unassignedSponsoredPeopleEc.plugins.currentEntityPlugin.feature.selectors
    .isEditing()
    .asSignal();

<div class="atn-space-report-usp">
  <div class="atn-space-report-usp__data">
    <atn-ds-table [config]="unassignedSponsoredPeopleTableConfig">
      <div
        class="atn-space-report-usp__actions"
        customTools
      >
        <i
          class="atn-icon atn-funnel atn-blue atn-space-report-usp__action-icon"
          [class.atn-space-report-usp__icon-with-info]="hasAppliedFiltersSg()"
          (click)="filtersClickHandler()"
        ></i>
      </div>
    </atn-ds-table>
  </div>

  @if (!isStandardUserSg()) {
    <atn-ds-widget title="Configuration">
      <div class="atn-space-report-usp__configuration">
        <atn-ds-checkbox
          label="Show Salary Information"
          [selected]="configurationSg().showSalaryInformation"
          (selectedChange)="showSalaryInformationChangeHandler($event)"
        />
      </div>
    </atn-ds-widget>
  }
</div>

@if (isEditingParams) {
  <atn-space-unassigned-sponsored-people-filters />
}

@if (isEditingComment) {
  <atn-space-unassigned-sponsored-comment-modal
    [collection]="unassignedSponsoredPeopleEc"
  />
}
